<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col class="card-col">
          <div class="row card-row-bg card-row wrap">
            <div
              v-for="(card, index) in parentCategory.PDI"
              :key="index"
              :ref="`card_${index}`"
              @mouseover="hoverCard(index)"
              @mouseout="hoverCard(-1)"
              @click="category(card)"
              class="card"
            >
              <div>
                <img
                  class="card-image"
                  :class="{ selected: isSelected(index) }"
                  @load="onLoaded"
                  @error="onImageLoadFailure($event)"
                  v-show="loaded"
                  :src="urlImage + card.name + '.png'"
                />

                <img
                  class="card-image"
                  v-show="loaded == false"
                  src="@/assets/loader.gif"
                />
              </div>

              <div class="card-footer">
                <h3 class="card-text">{{ card.name }}</h3>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PDI",

  components: {},

  data() {
    return {
      selectedCard: -1,
      loaded: false,
      urlImage:
        "https://risoulimages.s3.us-west-2.amazonaws.com/IMAGENES+NIVELES/PDI/GRAL/",
    };
  },

  props: {
    parentCategory: { type: Object },
    sendSnack: { type: Function },
  },

  methods: {
    category: function (item) {
      var select = item.name;
      var idSelected = item.id;
      this.$router.push(
        `/PDI/${encodeURIComponent(select)}?idCategory=${idSelected}`
      );
    },

    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex;
    },

    isSelected(cardIndex) {
      return this.selectedCard === cardIndex;
    },

    onLoaded() {
      this.loaded = true;
    },

    onImageLoadFailure(event) {
      event.target.src =
        "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/GENERICA RISOUL.png";
    },
  },

  computed: {},

  watch: {
    "$route.query": function () {
      this.$router.go();
    },
  },

  created() {
    document.title = "Risoul - Soluciones PDI";
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
